import {durationUnits} from 'utilities/helper/durationUnitsOption';
import {rateUnits} from 'utilities/helper/rateUnitsOptions';

export const initialValues: IOnSaleInitialValues = {
  price: '',
  min_price: '',
  duration: '',
  duration_unit: durationUnits[0].value?.toString(),
  decline_rate: '',
  rate_unit: rateUnits[0].value?.toString(),
};
export const initialValuesCreator = (
  productDetail?: IGetPostDetail,
  postEditDetail?: IPostEditDetail,
): IOnSaleInitialValues => {
  return {
    price: String(productDetail?.price) || '',
    min_price: String(postEditDetail?.min_price) || '',
    duration: String(postEditDetail?.duration) || '',
    duration_unit:
      postEditDetail?.duration_unit || durationUnits[0].value?.toString(),
    decline_rate: String(postEditDetail?.decline_rate) || '',
    rate_unit: postEditDetail?.financial_type || rateUnits[0].value?.toString(),
  };
};
